"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAudioConstraints = exports.resetVideoSource = exports.refreshDevices = exports.checkAVPermissions = exports.requestMediaPermissions = exports.changeVideoResolution = exports.setupMediaDevices = exports.updateConstraints = exports.changeAudioDestination = exports.gotDevices = void 0;
const utils_1 = require("../webaudio/utils");
const audioprocessor_1 = require("../webaudio/audioprocessor");
const reactive_1 = __importDefault(require("../general/reactive"));
const permissions_1 = require("../media/permissions");
Object.defineProperty(exports, "checkAVPermissions", { enumerable: true, get: function () { return permissions_1.checkAVPermissions; } });
Object.defineProperty(exports, "requestMediaPermissions", { enumerable: true, get: function () { return permissions_1.requestMediaPermissions; } });
const $ = require('jquery');
// npm install --save @types/jquery
let inputs = [];
let outputs = [];
let oldInputs = [];
let oldOutputs = [];
let selectors = [] = [];
let audioInputSelect = [];
let videoInputSelect = [];
let audioOutputSelect = [];
let videoResolution = '1080p';
// strings
const deniedPermissionsMessage = 'You have denied the necessary permissions to use Anywhere. Please go to Chrome Settings and enable them.';
let hasEchoCancellation = true; // echo cancelation on by default
;
let browser = { browser: null, version: null, iphone: false };
let isHost = false;
const mediaDevices = new reactive_1.default();
function localNotify(message, type = "notify") {
    mediaDevices.emit('NOTIFY', message, type);
}
class MediaDevices {
    constructor() {
        this.hasEchoCancellation = true;
        this.browser = { browser: null, version: null, iphone: false };
    }
}
function setupMediaDevices(_browser, product, role) {
    // set the default value for the product, for presenter its 360p
    videoResolution = product === 'presenter' ? '144p' : '1080p';
    browser = _browser;
    isHost = role == 'host';
    $(document).ready(() => {
        if (product === 'anywhere') {
            (0, permissions_1.checkAVPermissions)({
                microphone: true,
                camera: false,
                midi: true,
            }).then((granted) => {
                const permissionWrapper = $('#requestMediaPermissionsWrapper');
                permissionWrapper.toggleClass('hidden', granted);
            });
        }
        hasEchoCancellation = !(role == 'talent' || role == 'host');
        hasEchoCancellation = (hasEchoCancellation || product == 'presenter');
        setupMediaDevicesUI();
    });
    return mediaDevices;
}
exports.setupMediaDevices = setupMediaDevices;
function setupMediaDevicesUI() {
    // For Anywhere talent
    $('#refreshDevices').on('click', refreshDevices);
    $('#requestMediaPermissions').click(() => {
        (0, permissions_1.requestMediaPermissions)({ audio: true, video: false }, true)
            .then((stream) => {
            const permissionWrapper = $('#requestMediaPermissionsWrapper');
            permissionWrapper.addClass('hidden');
        })
            .catch((err) => {
            if (err.name === 'NotAllowedError' || err.name === 'SecurityError') {
                const permissionWrapper = $('#requestMediaPermissionsWrapper');
                permissionWrapper.html(deniedPermissionsMessage);
                permissionWrapper.addClass('text-red-600');
            }
            else {
                console.error(err);
            }
        });
    });
    // @Anywhere
    $('#toggleHQA').on('click', () => {
        const toggleHQA = $('#toggleHQA');
        let toggled = toggleHQA.children('input').prop('checked');
        toggled = !toggled;
        toggleHQA.children('input').prop('checked', toggled);
        const audioCodec = toggled ? 'audio/opus' : 'audio/ISAC';
        mediaDevices.emit('SET_AUDIO_CODEC', audioCodec);
    });
    // TODO: SHARE SCREEN IS NOT WORKING
    $('#shareScreen').on('click', () => {
        const localSource = $(".audioSource[data-id='0']").val();
        const videoSource = 'SCREEN';
        const constraints = [buildConstraints(getVideoConstraints(videoSource), getAudioConstraints(localSource, hasEchoCancellation))];
        // ADD CONSTRAINT STREAM TO THE STREAM MANAGER
        updateConstraints();
    });
}
function addNoneOptions(selects, text = "None") {
    selects.forEach((el) => {
        el.innerHTML = '';
        const defaultOption = document.createElement('option');
        defaultOption.value = 'NOT_SELECTED';
        defaultOption.text = 'None';
        defaultOption.selected = false;
        el.appendChild(defaultOption);
    });
}
function setSelectors() {
    if (selectors.length > 0)
        return;
    // inputs and outputs
    document.querySelectorAll('select.audioSource').forEach((el) => {
        audioInputSelect.push(el);
    });
    document.querySelectorAll('select.videoSource').forEach((el) => {
        videoInputSelect.push(el);
    });
    document.querySelectorAll('select.audioOutput').forEach((el) => {
        audioOutputSelect.push(el);
    });
    // audioOutputSelect.disabled = !('sinkId' in HTMLMediaElement.prototype);
    selectors = [videoInputSelect, audioInputSelect, audioOutputSelect];
}
function setListenersForSelectors(videoInputSelect, audioInputSelect, audioOutputSelect) {
    videoInputSelect.forEach((el) => {
        el.onchange = changeVideoInput;
        el.onclick = (e) => { e.preventDefault(); refreshDevices(); };
    });
    audioInputSelect.forEach((el) => {
        el.onchange = changeAudioInput;
        el.onclick = (e) => { e.preventDefault(); refreshDevices(); };
    });
    audioOutputSelect.forEach((el) => {
        el.onchange = changeOutput;
        el.onclick = (e) => { e.preventDefault(); refreshDevices(); };
    });
}
function clearSelectors() {
    selectors.forEach((selector) => {
        selector.forEach((el) => {
            while (el.firstChild) {
                el.removeChild(el.firstChild);
            }
        });
    });
}
function retrieveSelectedFromLocalStorage() {
    // retrieve default audio outputs
    for (let i = 0; i < 5; i += 1) {
        const preferredVideoSource = localStorage.getItem(`preferredVideoSource${i}`);
        $(`.videoSource[data-id='${i}']`).children(`option:contains("${preferredVideoSource}")`).prop({ selected: true });
        const preferredAudioInput = localStorage.getItem(`preferredAudioInput${i}`);
        $(`.audioSource[data-id='${i}']`).children(`option:contains("${preferredAudioInput}")`).prop({ selected: true });
        const preferredOutput = localStorage.getItem(`preferredAudioOutput${i}`);
        $(`.audioOutput[data-id='${i}']`).children(`option:contains("${preferredOutput}")`).prop({ selected: true });
    }
}
function checkInvalidInputs() {
    for (let i = 0; i < 5; i += 1) {
        const style = 'border-solid bg-red-200 border-2 border-red-300';
        let value = $(`.videoSource[data-id='${i}']`).val();
        $(`.videoSource[data-id='${i}']`).toggleClass(style, value === 'NOT_SELECTED');
        value = $(`.audioSource[data-id='${i}']`).val();
        $(`.audioSource[data-id='${i}']`).toggleClass(style, value === 'NOT_SELECTED');
        value = $(`.audioOutput[data-id='${i}']`).val();
        $(`.audioOutput[data-id='${i}']`).toggleClass(style, value === 'NOT_SELECTED');
    }
}
function addOptionsToSelectors(deviceInfos) {
    for (let i = 0; i !== deviceInfos.length; ++i) {
        const deviceInfo = deviceInfos[i];
        const option = document.createElement('option');
        option.value = deviceInfo.deviceId;
        if (deviceInfo.kind === 'videoinput' && isHost && videoInputSelect.length) {
            inputs.push(deviceInfo);
            option.text = deviceInfo.label || `videoSource ${videoInputSelect.length ? videoInputSelect[0].length + 1 : ''}`;
            videoInputSelect.forEach((el) => {
                el.append(option.cloneNode(true));
            });
        }
        else if (deviceInfo.kind === 'audioinput') {
            inputs.push(deviceInfo);
            option.text = deviceInfo.label || `microphone ${audioInputSelect[0].length + 1}`;
            if (option.value == 'default') {
                option.text = 'Use system default';
            }
            audioInputSelect.forEach((el) => {
                el.append(option.cloneNode(true));
            });
        }
        else if (deviceInfo.kind === 'audiooutput') {
            outputs.push(deviceInfo);
            option.text = deviceInfo.label || `speaker ${audioOutputSelect[0].length + 1}`;
            if (option.value == 'default') {
                option.text = 'Use system default';
            }
            audioOutputSelect.forEach((el) => {
                el.append(option.cloneNode(true));
            });
        }
        else {
            // ignore any other type of device, it wont be shown
            // console.log('Some other kind of source/device: ', deviceInfo);
        }
    }
}
function gotDevices(deviceInfos) {
    if (deviceInfos === null || deviceInfos == undefined)
        return;
    // Handles being called several times to update labels. Preserve values in a list.
    const values = selectors.map((select) => {
        return select.map((el) => {
            return { id: el.dataset.id, value: el.value, };
        });
    });
    if (selectors.length == 0) {
        setSelectors(); // get the array of selectors, idk why im doing this
        if (isHost)
            addNoneOptions(videoInputSelect); // add a "none" options 
        addNoneOptions(audioInputSelect, "Select your microphone"); // add a "none" options 
        addNoneOptions(audioOutputSelect, "Select your headphones"); // add a "none" options 
        addOptionsToSelectors(deviceInfos); // set the options from the deviceInfos
        setListenersForSelectors(selectors[0], selectors[1], selectors[2]);
    }
    if (isHost)
        retrieveSelectedFromLocalStorage();
    updateConstraints();
    // @Mirror: override director to set to none
    $(".audioOutput[data-id='3']").children('option:contains("None")').prop({ selected: true });
    checkInvalidInputs(); // for UI purposes
    validateAudioInputs(); // for UI purposes
    // restore values after re-creation
    selectors.forEach((select, selectorIndex) => {
        const valuesType = values[selectorIndex];
        if (valuesType == undefined)
            return;
        select.forEach((el, elIndex) => {
            // this may be out of bounds if something gets disconnected
            if (valuesType[elIndex] && valuesType[elIndex].value) {
                $(el).children(`option:contains("${valuesType[elIndex].value}")`).prop({ selected: true });
            }
        });
    });
}
exports.gotDevices = gotDevices;
function comparer(otherArray) {
    return function (current) {
        return otherArray.filter((other) => other.label == current.label && other.deviceId == current.deviceId).length == 0;
    };
}
function refreshDevices() {
    oldInputs = inputs;
    oldOutputs = outputs;
    navigator.mediaDevices.enumerateDevices().then(checkNewDevices).catch(handleError);
}
exports.refreshDevices = refreshDevices;
async function _getDevices() {
    const devices = {
        cameras: [], microphones: [], speakers: [], unknown: [],
    };
    const enumerateDevices = await navigator.mediaDevices.enumerateDevices();
    enumerateDevices.forEach((dev) => {
        const type = dev.kind == 'audioinput' ? 'microphones'
            : dev.kind == 'audiooutput' ? 'speakers'
                : dev.kind == 'videoinput' ? 'cameras'
                    : 'unknown';
        devices[type].push({ id: dev.deviceId, type: dev.kind, name: dev.label || dev.deviceId });
    });
    return devices;
}
function checkNewDevices(deviceInfos) {
    inputs = deviceInfos.filter((device) => device.kind == 'audioinput' || device.kind == 'videoinput');
    outputs = deviceInfos.filter((device) => device.kind == 'audiooutput');
    let newDevices = false;
    const removedInputs = oldInputs.filter(comparer(inputs));
    const newInputs = inputs.filter(comparer(oldInputs));
    // Check new Inputs
    removedInputs.forEach((input) => {
        newDevices = true;
        // remove these inputs from the selectors
        if (input.kind == 'audioinput') {
            audioInputSelect.forEach((el) => {
                $(el).children(`option:contains("${input.label}")`).remove();
            });
        }
        if (input.kind == 'videoinput') {
            videoInputSelect.forEach((el) => {
                $(el).children(`option:contains("${input.label}")`).remove();
            });
        }
    });
    newInputs.forEach((input) => {
        newDevices = true;
        if (input.kind == 'audioinput') {
            audioInputSelect.forEach((el) => {
                const option = document.createElement('option');
                option.value = input.deviceId;
                option.text = input.label || `microphone ${audioInputSelect[0].length + 1}`;
                if (option.value == 'default') {
                    // the default has updated, remove all the default options
                    $(el).children(`option:contains("Use system default")`).remove();
                    option.text = 'Use system default';
                }
                el.append(option.cloneNode(true));
            });
        }
        ;
        if (input.kind == 'videoinput') {
            videoInputSelect.forEach((el) => {
                const option = document.createElement('option');
                option.value = input.deviceId;
                option.text = input.label || `videoSource ${videoInputSelect.length ? videoInputSelect[0].length + 1 : ''}`;
                el.append(option.cloneNode(true));
            });
        }
    });
    // Check New Outputs
    const removedOutputs = oldOutputs.filter(comparer(outputs));
    const newOutputs = outputs.filter(comparer(oldOutputs));
    removedOutputs.forEach((output) => {
        newDevices = true;
        if (output.kind == 'audiooutput') {
            audioOutputSelect.forEach((el) => {
                $(el).children(`option:contains("${output.label}")`).remove();
            });
        }
    });
    newOutputs.forEach((output) => {
        newDevices = true;
        if (output.kind == 'audiooutput') {
            audioOutputSelect.forEach((el) => {
                const option = document.createElement('option');
                option.value = output.deviceId;
                option.text = output.label || `speaker ${audioOutputSelect[0].length + 1}`;
                if (option.value == 'default') {
                    option.text = 'Use system default';
                }
                el.append(option.cloneNode(true));
            });
        }
    });
    if (newDevices) {
        gotDevices(deviceInfos);
    }
}
function validateAudioInputs() {
    // host doesn't need validations
    if (isHost)
        return;
    const audioSource = $(".audioSource[data-id='0']").val();
    const audioOutput = $(".audioOutput[data-id='1']").val();
    // this is for the select_peripheral setup
    if (typeof window.listenInputChange !== 'undefined') {
        window.listenInputChange(audioSource != 'NOT_SELECTED' && (audioOutput != 'NOT_SELECTED' || !isHost));
    }
}
function changeVideoResolution(newVideoResolution) {
    videoResolution = newVideoResolution;
    updateConstraints();
}
exports.changeVideoResolution = changeVideoResolution;
function resetVideoSource() {
    $(".videoSource[data-id='0']").val('NOT_SELECTED');
    updateConstraints();
}
exports.resetVideoSource = resetVideoSource;
async function changeVideoInput(event) {
    const changingVideoEl = document.querySelector("#localVideoSettingChangingCamera");
    const id = parseInt($(event.target).data('id'));
    const label = $(event.target).children('option:selected').text();
    if (changingVideoEl && label !== "None") {
        changingVideoEl.style.display = "flex";
    }
    localStorage.setItem(`preferredVideoSource${id}`, label);
    retrieveSelectedFromLocalStorage(); // set the same on multiple selects
    checkInvalidInputs();
    updateConstraints();
}
function changeAudioInput(event) {
    // theres only one input though
    // check which input it is referring to
    const id = parseInt($(event.target).data('id'));
    const label = $(event.target).children('option:selected').text();
    localStorage.setItem(`preferredAudioInput${id}`, label);
    // update all other audio inputs that have the same id
    audioInputSelect.forEach((el) => {
        if (parseInt(el.dataset.id) == id)
            el.value = event.target.value;
    });
    // send to host new inputs
    mediaDevices.emit('SEND_SESSION_INFO');
    validateAudioInputs();
    updateConstraints();
    checkInvalidInputs();
}
function updateConstraints() {
    const localSource = $(".audioSource[data-id='0']").val();
    const videoSource = $(".videoSource[data-id='0']").val();
    // AUDIO AND VIDEO
    const constraints = {
        LOCAL_AUDIO: false,
        CAMERA_VIDEO: false,
        CAMERA_AUDIO: false,
        TALENT_AUDIO: false,
    };
    const constraint = buildConstraints(false, getAudioConstraints(localSource, hasEchoCancellation));
    constraints.LOCAL_AUDIO = constraint;
    // Video
    const videoConstraint = buildConstraints(getVideoConstraints(videoSource), false);
    constraints.CAMERA_VIDEO = videoConstraint;
    // CAMERA AUDIO
    const cameraSource = $(".audioSource[data-id='1']").val();
    let cameraConstraints = false;
    if (cameraSource) {
        cameraConstraints = buildConstraints(false, getAudioConstraints(cameraSource, hasEchoCancellation));
    }
    constraints.CAMERA_AUDIO = cameraConstraints;
    // TALENT AUDIO
    const talentSource = $(".audioSource[data-id='2']").val();
    if (talentSource) {
        const talentConstraints = buildConstraints(false, getAudioConstraints(talentSource, hasEchoCancellation));
        constraints.TALENT_AUDIO = talentConstraints;
    }
    mediaDevices.emit('GET_USER_MEDIA', constraints);
}
exports.updateConstraints = updateConstraints;
// type MediaConstrains = MediaTrackConstraints
function buildConstraints(videoConstraints, audioConstraints = false) {
    const constraints = { video: videoConstraints, audio: audioConstraints };
    return (videoConstraints || audioConstraints) ? constraints : false;
}
function changeOutput(event) {
    // check which output it is
    const id = parseInt($(event.target).data('id'));
    const label = $(event.target).children('option:selected').text();
    // set id accordingly
    localStorage.setItem(`preferredAudioOutput${id}`, label);
    audioOutputSelect.forEach((el) => {
        if (parseInt(el.dataset.id) == id)
            el.value = event.target.value;
    });
    changeAudioDestination(id);
    validateAudioInputs();
    checkInvalidInputs();
}
function setDestinationForGuests() {
    const destination = $(".audioOutput[data-id='0']").val();
    let audioEls = document.querySelectorAll('audio,video');
    if (browser && browser.browser === 'safari' && browser.version && browser.version >= 605) {
        // unmute every audio and video
        audioEls.forEach((audio) => {
            audio.muted = false;
        });
        audioEls.forEach((video) => {
            video.muted = false;
        });
    }
    if (destination == 'NOT_SELECTED' || !destination)
        return;
    audioEls.forEach((audio) => {
        (0, utils_1.attachSinkId)('everyone', audio, destination);
    });
    audioEls.forEach((audio) => {
        (0, utils_1.attachSinkId)('everyone', audio, destination);
    });
}
function changeAudioDestination(id) {
    if (!isHost) {
        setDestinationForGuests();
        return;
    }
    if (id == 0) {
        var guestDestination = $(".audioOutput[data-id='0']").val();
        const talentRecordingAudio = getAudiosWithSelector(".talent_recording_audio");
        setAudios("talentRecordingAudio", talentRecordingAudio, guestDestination);
        // Set local audio
        (0, utils_1.attachSinkId)('Local audio 1 (send)', $('#localAudio')[0], guestDestination);
        // This audio comes from host camera audio source
        (0, utils_1.attachSinkId)('Local audio 2 (send)', $('#localAudio2')[0], guestDestination);
        $('#localAudio')[0].muted = guestDestination == 'NOT_SELECTED';
        $('#localAudio2')[0].muted = guestDestination == 'NOT_SELECTED';
        (0, utils_1.attachSinkId)('Test Audio Headphones', $('#headphoneTestAudio')[0], guestDestination);
        const guestAudios = getAudiosWithSelector("[id^='audio_'][data-role='guest']");
        // guests audio
        setAudios("Guests", guestAudios, guestDestination);
        // directors audio
        setDirectorsAudio();
        // sound bar audio
        setSoundBarAudio();
        // mirror: set video playback audio
        setVideoPlaybackAudio();
        // mirror: set continuity audio
        setContinuityAudio();
    }
    // talents audio
    if (id == 1)
        setTalent1Audio();
    // talents audio
    if (id == 2)
        setTalent2Audio();
    // director to set audio
    if (id == 3)
        setDirectorToSetAudio();
    if (id == null || (typeof id === 'undefined')) {
        var guestDestination = $(".audioOutput[data-id='0']").val();
        // Set local audio (my audio, will be output to guestDestination (for monitoring))
        (0, utils_1.attachSinkId)('Local audio 1 (send)', $('#localAudio')[0], guestDestination);
        // This audio comes from host camera audio source (Mirror only)
        (0, utils_1.attachSinkId)('Local audio 2 (send)', $('#localAudio2')[0], guestDestination);
        if ($('#localAudio')[0] != undefined)
            $('#localAudio')[0].muted = guestDestination == 'NOT_SELECTED';
        if ($('#localAudio2')[0] != undefined)
            $('#localAudio2')[0].muted = guestDestination == 'NOT_SELECTED';
        if ($('#headphoneTestAudio').length > 0)
            (0, utils_1.attachSinkId)('Test Audio Headphones', $('#headphoneTestAudio')[0], guestDestination);
        const talentRecordingAudio = getAudiosWithSelector(".talent_recording_audio");
        setAudios("talentRecordingAudio", talentRecordingAudio, guestDestination);
        const guestAudios = getAudiosWithSelector("[id^='audio_'][data-role='guest']");
        setAudios("Guests", guestAudios, guestDestination);
        setDirectorsAudio();
        setTalent1Audio();
        setTalent2Audio();
        setDirectorToSetAudio();
        setSoundBarAudio();
        setVideoPlaybackAudio();
        setContinuityAudio();
    }
}
exports.changeAudioDestination = changeAudioDestination;
function getAudiosWithSelector(selector) {
    const audios = document.querySelectorAll(selector);
    var audiosArray = Array.from(audios);
    return audiosArray;
}
function setAudios(label, audios, destination) {
    if (audios == undefined || audios.length <= 0)
        return;
    audios.forEach((audioEl) => {
        audioEl.muted = destination == 'NOT_SELECTED';
        (0, utils_1.attachSinkId)(label, audioEl, destination);
    });
}
function setDirectorToSetAudio() {
    // director to set audio
    const assistantDestination = $(".audioOutput[data-id='3']").val();
    const directorAudios = $("[id^='director_to_set_'][data-role='director']");
    setAudios("Director to Set (director)", directorAudios, assistantDestination);
    const directorAssistantAudios = getAudiosWithSelector("[id^='director_to_set_'][data-role='production']");
    setAudios("Director to Set (production)", directorAssistantAudios, assistantDestination);
}
function setDirectorsAudio() {
    const directorDestination = $(".audioOutput[data-id='0']").val();
    // directors audio
    const directorAudios = getAudiosWithSelector("[id^='audio_'][data-role='director']");
    setAudios("Director", directorAudios, directorDestination);
    // production audio
    const productionAudios = getAudiosWithSelector("[id^='audio_'][data-role='production']");
    setAudios("Production (director)", productionAudios, directorDestination);
}
function setSoundBarAudio() {
    const soundBarDestination = $(".audioOutput[data-id='0']").val();
    // sound bar audios
    const soundBarAudios = getAudiosWithSelector('.soundBar');
    setAudios("Sound Wall", soundBarAudios, soundBarDestination);
}
function setVideoPlaybackAudio() {
    const videoPlaybackDestination = $(".audioOutput[data-id='0']").val();
    // video playback audios
    const videoAudio = getAudiosWithSelector('[id^=videoTakePlayback]');
    setAudios("Video playback", videoAudio, videoPlaybackDestination);
}
function setContinuityAudio() {
    const videoPlaybackDestination = $(".audioOutput[data-id='0']").val();
    // video playback audios
    const videoAudio = getAudiosWithSelector('.continuityPlayback');
    setAudios("Continuity playback", videoAudio, videoPlaybackDestination);
}
function setTalent1Audio() {
    const talentDestination1 = $(".audioOutput[data-id='1']").val();
    if (talentDestination1 == undefined || talentDestination1.length <= 0) {
        return;
    }
    const peerId = $(".audioOutput[data-id='1']")[0].getAttribute('data-peer--public-key');
    const talent1Audio = getAudiosWithSelector(`[id^='audio_${peerId}'][data-role='talent']`);
    setAudios("Talent 1", talent1Audio, talentDestination1);
}
function setTalent2Audio() {
    const talentDestination2 = $(".audioOutput[data-id='2']").val();
    if (talentDestination2 == undefined || talentDestination2.length <= 0) {
        return;
    }
    const peerId = $(".audioOutput[data-id='2']")[0].getAttribute('data-peer--public-key');
    const talent2Audio = getAudiosWithSelector(`[id^='audio_${peerId}'][data-role='talent']`);
    setAudios("Talent 2", talent2Audio, talentDestination2);
}
function getAudioConstraints(audioSource, hasEchoCancellation = true) {
    if (audioSource == 'NOT_SELECTED')
        return false;
    return {
        deviceId: audioSource ? { exact: audioSource } : undefined,
        autoGainControl: false,
        channelCount: 1, // 1 mono,  2 stereo
        // 'echoCancellation':false,
        // 'autoGainControl':false,
        // 'noiseSuppression':false
        // Note: We are disabling these, as it causes issues with some android devices
        // specifically we are seeing issues with a Pixel 4
        // sampleSize: 16, 
        // sampleRate: 48000,
        // noiseSuppression: 0,
        echoCancellation: hasEchoCancellation,
    };
}
exports.getAudioConstraints = getAudioConstraints;
function getVideoConstraints(videoSource) {
    if (videoSource == 'NOT_SELECTED' || videoSource == null || !isHost)
        return false;
    if (videoSource == 'SCREEN') {
        return { mediaSource: 'screen' };
    }
    let height = 1080;
    let width = 1920;
    switch (videoResolution) {
        case '4K':
            height = 2160;
            width = 3840;
            break;
        case '1080p':
            height = 1080;
            width = 1920;
            break;
        case '720p':
            height = 720;
            width = 1280;
            break;
        case '480p':
            height = 480;
            width = 854;
            break;
        case '360p':
            height = 360;
            width = 640;
            break;
        case '144p':
            height = 144;
            width = 256;
            break;
        case 'vertical':
            height = 640;
            width = 360;
            break;
        default:
            break;
    }
    const videoConstraints = {
        deviceId: videoSource ? { exact: videoSource } : undefined,
        width: {
            min: width - (width * 0),
            ideal: width,
            max: width + (width * 0),
        },
        height,
        aspectRatio: 1.777777778,
        frameRate: { ideal: 30, max: 30 },
    };
    return videoConstraints;
}
// ERROR HELPER
function handleError(error) {
    let errorContainerEl = document.querySelector('#error-container');
    if (errorContainerEl === null) {
        return;
    }
    errorContainerEl.classList.remove('hidden');
    const errorMessage = `There was an error: ${error}`;
    let errorMsgEl = document.querySelector('span#errorMsg');
    if (errorMsgEl === null) {
        return;
    }
    errorMsgEl.innerHTML = errorMessage;
    console.error(error);
}
// ignore these errors
// @ts-ignore
window.startWebAudio = audioprocessor_1.startWebAudio; // global because its used by select_peripherals
// @ts-ignore
window.handleError = handleError;
// @ts-ignore
window.changeOutput = changeOutput;
// @ts-ignore
window.changeAudioDestination = changeAudioDestination;
// @ts-ignore
window.gotDevices = gotDevices; // used in steps in talent form
